import {getGroupProduct, getPlanType, getProduct, getRiders} from 'ApplicationEntry/api/awdApi';
import ApplicationEntryRouteConstants from 'ApplicationEntry/ApplicationEntryRouteConstants';
import * as C from 'ApplicationEntry/ducks/ProductsRiders/cancer';
import {push} from 'connected-react-router';
import {AsyncResult, Loaded} from 'Core/models/Async';
import * as E from 'fp-ts/lib/Either';
import {all, call, put, takeLatest} from 'redux-saga/effects';
import * as RI from '../models/ProductsRiders/RiderInformation';

import * as I from 'immutable';
import {Plan, Product} from 'ApplicationEntry/models/ProductsRiders/PlanModel';

function* getCancerProducts() {
  yield takeLatest(C.CancerActionType.GET_CANCER_PRODUCTS, function*(action: ReturnType<typeof C.getCancerProducts>) {
    const response: AsyncResult<Product> = yield call(getProduct, action.payload.friendlyName);

    if (E.isRight(response)) {
      yield put(C.changeCancerProducts(new Loaded(response.right.plans!)));
    } else if (response.left.key === 'Unauthorized') {
      yield put(push(ApplicationEntryRouteConstants.AWDLogin));
    } else {
      yield put(C.changeCancerProducts(response.left));
    }
  });
}

function* getGroupCancerProducts() {
  yield takeLatest(C.CancerActionType.GET_GROUP_CANCER_PRODUCTS, function*(
    action: ReturnType<typeof C.getGroupCancerProducts>
  ) {
    const {payload} = action;
    const {caseNumber, planCode} = payload;
    const response: AsyncResult<{packages: object[]}> = yield call(getGroupProduct, caseNumber, planCode);

    if (E.isRight(response)) {
      yield put(C.changeGroupCancerProducts(new Loaded(response.right.packages)));
    } else if (response.left.key === 'Unauthorized') {
      yield put(push(ApplicationEntryRouteConstants.AWDLogin));
    } else {
      yield put(C.changeGroupCancerProducts(response.left));
    }
  });
}

function* getCancerPlanTypes() {
  yield takeLatest(C.CancerActionType.GET_CANCER_PLANTYPES, function*(action: ReturnType<typeof C.getCancerPlanTypes>) {
    const response: AsyncResult<{planTypes: string[]}> = yield call(
      getPlanType,
      action.payload.family,
      action.payload.product
    );

    if (E.isRight(response)) {
      yield put(C.changeCancerPlanTypes(new Loaded(response.right.planTypes)));
    } else if (response.left.key === 'Unauthorized') {
      yield put(push(ApplicationEntryRouteConstants.AWDLogin));
    } else {
      yield put(C.changeCancerPlanTypes(response.left));
    }
  });
}

function* getCancerRiderCodes() {
  yield takeLatest(C.CancerActionType.GET_CANCER_RIDERCODES, function*(
    action: ReturnType<typeof C.getCancerRiderCodes>
  ) {
    const response: AsyncResult<{
      riders: [{code: string; units: string[]; displayName: string; tracInput: null; classBase: null}];
    }> = yield call(getRiders, action.payload.product);

    if (E.isRight(response)) {
      const riderInformation = new RI.default(
        I.List<string>(),
        I.List<number>(),
        response.right.riders as RI.RiderCode[]
      );
      yield put(C.changeCancerRiderInformation(new Loaded(riderInformation)));
    } else if (response.left.key === 'Unauthorized') {
      yield put(push(ApplicationEntryRouteConstants.AWDLogin));
    } else {
      yield put(C.changeCancerRiderCodes(response.left));
    }
  });
}

export default function*() {
  yield all([getCancerProducts(), getCancerPlanTypes(), getCancerRiderCodes(), getGroupCancerProducts()]);
}
